import { useState } from "react"

const SHOW_TRANSLATION_KEY = "show-translation"

// Off by default — only enabled when the reader has explicitly turned it on.
const readShowTranslation = (): boolean =>
  localStorage.getItem(SHOW_TRANSLATION_KEY) === "true"

export function useTranslationPreference() {
  const [showTranslation, setShowTranslationState] =
    useState<boolean>(readShowTranslation)

  const setShowTranslation = (next: boolean) => {
    localStorage.setItem(SHOW_TRANSLATION_KEY, String(next))
    setShowTranslationState(next)
  }

  return { showTranslation, setShowTranslation }
}
